import React from "react";
import Header from "../../components/header/Header";
import ServicesContainer from "../../containers/service/Services-list";
import ServicesO from "./Services";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";

const Services = (props) => {
    const theme = props.theme;
    return (
        <div className="experience-main">
            <Header theme={theme} />
            <ServicesO theme={props.theme} />
            <ServicesContainer theme={props.theme} />
            <Footer theme={props.theme} onToggle={props.onToggle} />
            <TopButton theme={props.theme} />
        </div>

    );
}

export default Services;
